import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  Input,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { AuthContext } from "../Contexts/AuthContextProvider";

const CardComponent = ({ _id, image, name, cuisine, description ,getData}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { token } = React.useContext(AuthContext);
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [names, setName] = useState(name);
  const [cuisines, setCuisine] = useState(cuisine);
  const [descriptions, setDescription] = useState(description);
  const [images, setImage] = useState(image);


  const deleteRecipe = async (_id) => {
    console.log(_id);
    await fetch(
      `https://dull-tan-drill-gear.cyclic.app/recipes/delete/${_id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: token,
        },
      }
    );
  };
  const updateRecipe = async (_id) => {
    

    const payload = {
      name: names,
      cuisine: cuisines,
      description: descriptions,
      image: images,
    };
    // console.log(_id);
    // console.log(payload);
    await fetch(
      `https://dull-tan-drill-gear.cyclic.app/recipes/update/${_id}`,
      {
        method: "PATCH",
        body: JSON.stringify({ ...payload }),
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
  };
  return (
    <Box m={"30px"} key={_id}>
      <Image src={image} alt="" />
      <Heading textAlign={"center"} as={"h3"} size="md">
        {name}
      </Heading>
      <Heading textAlign={"center"} as={"h3"} size="md">
        {cuisine}
      </Heading>
      <Text height={"100px"}>{description}</Text>
      <Flex justifyContent={"space-around"}>
        <Button onClick={onOpen} variant={"outline"} colorScheme={"teal"}>
          Update Recipe
        </Button>
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Update Recipe</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <Input
                value={names}
                onChange={(e) => setName(e.target.value)}
                // ref={initialRef}
                placeholder="Please Enter Recipe Name"
              />

              <Input
                value={cuisines}
                onChange={(e) => setCuisine(e.target.value)}
                placeholder="Please Enter Cuisine Type"
              />

              <Input
                value={descriptions}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Please Enter Description"
              />

              <Input
                value={images}
                onChange={(e) => setImage(e.target.value)}
                placeholder="Please Enter Image Url"
              />
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => {
                  if (
                    descriptions !== "" &&
                    names !== "" &&
                    cuisines !== "" &&
                    images !== ""
                  ) {
                    updateRecipe(_id, name, cuisine, description, image);
                    onClose();
                    getData();
                  }
                }}
                disabled={
                  descriptions === "" &&
                  names === "" &&
                  cuisines === "" &&
                  images === ""
                    ? true
                    : false
                }
              >
                Update
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Button
          onClick={() => {
            deleteRecipe(_id);
            getData();
          }}
          variant={"outline"}
          colorScheme={"teal"}
        >
          Delete Recipe
        </Button>
      </Flex>
    </Box>
  );
};

export default CardComponent;
